// src/components/exam/ExamTabsContainer.jsx
import React, { useState } from 'react';
import {
  FileText, Award, Users, CalendarClock
} from 'lucide-react';

// Import your real components
import ExamAssessmentManager from './ExamAssessmentManager';
import Grade from './Grade'; // ← This one now has its own exam dropdown inside
import ExamSchedule from './ExamSchedule'; // ← Add this import
import './ExamTabsContainer.css';

export default function ExamTabsContainer({ orgId }) {
  const [activeTab, setActiveTab] = useState('details'); // or 'grade'

  const tabs = [
    {
      id: 'details',
      label: 'Examinations',
      icon: Users,
      component: ExamAssessmentManager
    },
    {
      id: 'schedule',
      label: 'Schedule',
      icon: CalendarClock,
      component: ExamSchedule
    },
    {
      id: 'grade',
      label: 'Grade',
      icon: Award,
      component: Grade
    },
  ];

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component || tabs[0].component;

  return (
    <div className="exam-tabs-container min-h-screen bg-gray-50">
      {/* Clean Header — No exam selector here anymore */}
      <div className="bg-white border-b border-gray-200 px-6 py-5">

      </div>

      {/* Tabs Navigation */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto">
          <div className="exam-tabs-nav">
            {tabs.map(tab => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.id;

              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`exam-tab-button ${isActive ? 'active' : ''}`}
                >
                  <Icon size={18} className="exam-tab-icon" />
                  <span className="exam-tab-label">{tab.label}</span>
                  {isActive && <div className="exam-tab-indicator" />}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Tab Content */}
      <div className="exam-tab-content py-6">
        <div className="max-w-7xl mx-auto">
          <ActiveComponent orgId={orgId} />
        </div>
      </div>
    </div>
  );
}